import { ReactElement } from 'react';
import LikelyPossibilities from '@components/FVSPage/LikelyPossibilities';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep10(): ReactElement {
  return (
    <>
      <LikelyPossibilities displayObject={fvsInfoDisplayObject} currentStepNo="step10" />
    </>
  );
}

export default FVSStep10;
